<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 5a8.73 8.73 0 018.71 8.73C24.71 17 19.82 23 16 26.82 12.18 23 7.29 17 7.29 13.73A8.73 8.73 0 0116 5m0-2A10.73 10.73 0 005.29 13.73c0 4.58 6.38 11.54 9.29 14.48a2 2 0 002.84 0c2.91-2.94 9.29-9.9 9.29-14.48A10.73 10.73 0 0016 3z"/><path d="M20 12.56l-2.17-2.17-1.31-1.34a.71.71 0 00-1 0l-1.35 1.34L12 12.56l-.94.95a.72.72 0 00.51 1.23h8.92a.72.72 0 00.51-1.23z"/></svg>